import { Typography, Button } from "../../components"
import "./styles.css";

export default function Klachtenregeling(props) {
    return (
        <div className='container'>
            <Typography type='h1' style={{ color: 'var(--trust)', fontSize: '2.2em' }}>Klachtenregeling</Typography>
            <div className="button-container">
                <Button 
                    target='_blank' 
                    href={'https://www.babyfeeding.nl/media/general/klachtenregeling/document/digital.pdf'} 
                    text={`Download de klachtenregeling`}
                />
            </div>
        </div>
    )
}